import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 29 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17.942 14q0 .233-.073.437a1 1 0 0 1-.248.38l-5.367 5.366q-.32.32-.817.32-.495 0-.816-.32a1.1 1.1 0 0 1-.321-.817q0-.495.32-.816L15.17 14l-4.55-4.55a1.1 1.1 0 0 1-.32-.817q0-.495.32-.817.322-.32.817-.32t.817.32l5.367 5.367q.174.175.248.38.072.203.073.437" }, null, -1)
  ])))
}
export default { render: render }